import React from 'react';
import styles from './ApiStatusModal.module.scss';

const ApiStatusModal = ({ isVisible }) => {
  if (!isVisible) return null;

  const handleRefresh = () => {
    window.location.reload();
  };

  return (
    <div className={styles.overlay}>
      <div className={styles.modal}>
        <div className={styles.spinnerContainer}>
          <div className={styles.spinner}>
            <div className={styles.circle}></div>
            <div className={styles.circle}></div>
            <div className={styles.circle}></div>
          </div>
        </div>
        
        <div className={styles.content}>
          <h2 className={styles.title}>Система обновляется</h2>
          <p className={styles.message}>
            Сервер временно недоступен. Пожалуйста, подождите...
          </p>
          <p className={styles.submessage}>
            Подключение будет восстановлено автоматически
          </p>
          
          <button className={styles.refreshButton} onClick={handleRefresh}>
            Обновить сейчас
          </button>
        </div>
        
        <div className={styles.pattern}>
          <div className={styles.ornament}></div>
        </div>
      </div>
    </div>
  );
};

export default ApiStatusModal;
